// extracted by mini-css-extract-plugin
export default {"optionLabel":"styles-module__optionLabel__src-labstep-web-core-Select-Search-_WHHLH"};